import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import styled from 'styled-components';
const Wrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 28px;
  height: 28px;
  overflow: hidden;
`;
const Ribbon = styled.div `
  font-weight: 700;
  font-size: 8px;
  line-height: 10px;
  transform: rotate(315deg) translateX(-11px) translateY(-3px);
  display: flex;
  justify-content: center;
  width: 40px;
  text-transform: uppercase;
  background-color: ${({ theme, variant }) => (variant === 'beta' ? theme.colors.warning10_2 : theme.colors.positive10_2)};
  color: ${({ theme, variant }) => (variant === 'beta' ? theme.colors.warning120_2 : theme.colors.positive120_2)};
`;
export const CornerBadge = memo(function CornerBadge({ variant }) {
    return (_jsx(Wrapper, { children: _jsx(Ribbon, { variant: variant, children: variant }) }));
});
